import { Card, Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import '../candidateRightContentPane/candidateFamilyDetailsPanel.css';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import CloseIcon from '../../../assets/images/Ic_close.png';
import SigniteToggle from '../../ui-elements/toggle-switch/signiteToggleSwitch';

const CandidateFamilyDetailsPanel = ({ familyDetails, maritalStatus, setMaritalStatus }) => {

  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [modalState, setModalState] = useState({
    maritalStatus: maritalStatus,
    spouseOccupation: _.get(familyDetails, 'spouseCurrentOccupation', ''),
    hasChildren: _.get(familyDetails, 'hasChildren', 'NO'),
    numChildren: _.get(familyDetails, 'noOfChildren', ''),
  });

  const [displayState, setDisplayState] = useState({
    spouseOccupation: _.get(familyDetails, 'spouseCurrentOccupation', ''),
    hasChildren: _.get(familyDetails, 'hasChildren', 'NO'),
    numChildren: _.get(familyDetails, 'noOfChildren', ''),
  });

  useEffect(() => {
    setModalState((prev) => ({ ...prev, maritalStatus }));
  }, [maritalStatus]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setModalState(prev => ({ ...prev, [name]: value }));
  };

  const handleToggleChange = (value) => {
    setModalState(prev => ({
      ...prev,
      hasChildren: value ? 'YES' : 'NO',
      numChildren: value ? prev.numChildren : 0,
    }));
  };

  const handleModalSave = async () => {
    try {
      setLoading(true);
      const payload = {
        maritalStatus: modalState.maritalStatus,
        spouseCurrentOccupation: modalState.maritalStatus === 'MARRIED' ? (modalState.spouseOccupation || 'NOT_APPLICABLE') : 'NOT_APPLICABLE',
        hasChildren: modalState.maritalStatus === 'MARRIED' ? modalState.hasChildren : 'NO',
        noOfChildren: modalState.maritalStatus === 'MARRIED' && modalState.hasChildren === 'YES' ? parseInt(modalState.numChildren || '0') : 0,
      };

      await CandidatePostLoginService.submitPanelByType('FAMILY_DETAILS', payload);
      // await CandidatePostLoginService.submitFamilyDetails(payload);
      setMaritalStatus(modalState.maritalStatus);

      setDisplayState({
        spouseOccupation: payload.spouseCurrentOccupation,
        hasChildren: payload.hasChildren,
        numChildren: payload.noOfChildren,
      });

      setModalShow(false);
    } catch (error) {
      console.error("Failed to update family details", error);
      alert("Error updating details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleModalCancel = () => {
    setModalState(prev => ({
      ...prev,
      maritalStatus,
      spouseOccupation: displayState.spouseOccupation,
      hasChildren: displayState.hasChildren,
      numChildren: displayState.numChildren,
    }));
    setModalShow(false);
  };

  return (
    <Card className="familyDetailsPanel mt-2">
      <Card.Body>
        <Container>
          <Row>
            <Col><h3 style={{ whiteSpace: 'nowrap' }}>Family Details</h3></Col>
            <Col className="text-end">
              <FontAwesomeIcon
                icon={faPen}
                className="me-1"
                size="sm"
                style={{ color: "#F35824", cursor: 'pointer' }}
                onClick={() => setModalShow(true)}
              />
            </Col>
          </Row>

          {maritalStatus === 'MARRIED' && displayState.spouseOccupation && displayState.spouseOccupation !== 'NOT_APPLICABLE' && (
            <Row className="mb-2 align-items-center">
              <Col md={4}><span className="label">Spouse's Role</span></Col>
              <Col md={8}><span className="label professionValue">{displayState.spouseOccupation}</span></Col>
            </Row>
          )}

          {maritalStatus === 'MARRIED' && displayState.hasChildren === 'YES' && (
            <Row className="mb-2 align-items-center">
              <Col md={4}><span className="label">No. of Children</span></Col>
              <Col md={8}><span className="label professionValue">{displayState.numChildren}</span></Col>
            </Row>
          )}

          <Modal show={modalShow} onHide={handleModalCancel} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
            <Modal.Header className="d-flex justify-content-between align-items-center">
              <Modal.Title>Edit Family Details</Modal.Title>
              <img
                src={CloseIcon}
                alt="Close"
                onClick={handleModalCancel}
                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
              />
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="maritalStatus">
                    <Form.Label>Marital Status</Form.Label>
                    <Form.Select
                      name='maritalStatus'
                      value={modalState.maritalStatus}
                      onChange={handleChange}
                      style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                    >
                      <option value="SINGLE">Single</option>
                      <option value="MARRIED">Married</option>
                      <option value="DONT_WANT_TO_SPECIFY">Don't want to specify</option>
                    </Form.Select>
                  </Form.Group>
                </Row>

                {modalState.maritalStatus === 'MARRIED' && (
                  <>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId={`spouseOccupation`}>
                        <Form.Label>Spouse's Current Occupation</Form.Label>
                        <Form.Select
                          name={'spouseOccupation'}
                          onChange={handleChange}
                          value={modalState.spouseOccupation}
                          style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                        >
                          <option value="NOT_APPLICABLE">--Select--</option>
                          <option value="SERVICE">Service</option>
                          <option value="SELF_EMPLOYED">Self Employed</option>
                          <option value="RETIRED">Retired</option>
                        </Form.Select>
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group as={Row} controlId={'haveChildren'}>
                        <Col>
                          <Form.Label>Do you have children?</Form.Label>
                          <SigniteToggle
                            id={'haveChildren'}
                            dataYes={'Yes'}
                            dataNo={'No'}
                            fieldInput={{
                              onChange: (e) => handleToggleChange(e.target.checked),
                              value: modalState.hasChildren === 'YES',
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </Row>

                    {modalState.hasChildren === 'YES' && (
                      <Row className="mb-3">
                        <Form.Group as={Col} controlId="noOfChildren">
                          <Form.Label>Number of Children</Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            max={25}
                            name={`numChildren`}
                            onChange={handleChange}
                            value={modalState.numChildren}
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                          />
                        </Form.Group>
                      </Row>
                    )}
                  </>
                )}
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <button onClick={handleModalCancel} className="candidate-profile-edit-cancel">Cancel</button>
              <button
                onClick={handleModalSave}
                className="candidate-profile-edit-save"
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
            </Modal.Footer>
          </Modal>
        </Container>
      </Card.Body>
    </Card>
  );
};

export default CandidateFamilyDetailsPanel;
